const config = {
  title: 'Layout 3 Full Layout',
  defaults: {
    mode: 'fullwidth',
    navbar: {
      display: false
    },
    toolbar: {
      display: false
    },
    footer: {
      display: false
    },
    leftSidePanel: {
      display: false
    },
    rightSidePanel: {
      display: false
    }
  }
};

export default config;
